import React, { useState, useEffect } from 'react';
import { Box, Typography, Popover, Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  stepQuestion: {
    display: 'flex',
    justifyContent: 'center',
    '& button': {
      minWidth: 140,
      color: theme.palette.common.gamsDarkBlue,
      borderColor: theme.palette.common.gamsDarkBlue,
      '&:hover': {
        backgroundColor: theme.palette.common.blue[600],
        color: theme.palette.common.white,
      },
      '&:focus': {
        outline: 'none',
      },
      '&:active': {
        backgroundColor: theme.palette.common.blue[600],
        color: theme.palette.common.white,
      },
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '100%',
    minHeight: '60px',
  },
}));

const EditScorePopover = ({ 
  open, 
  anchorEl, 
  onClose, 
  onConfirm, 
  stepIndex,
  currentScore,
  maxScore
}) => {
  const classes = useStyles();
  const [newScore, setNewScore] = useState("");

  // Aggiorna il valore quando si apre il popover con il currentScore
  useEffect(() => {
    if (open && currentScore !== undefined) {
      setNewScore(currentScore.toString());
    }
  }, [open, currentScore]);

  const handleClose = () => {
    setNewScore(""); 
    onClose();
  };

  const handleConfirm = () => {
    const scoreValue = parseInt(newScore);
    
    // Validazione del valore
    if (isNaN(scoreValue) || scoreValue < 0 || scoreValue > maxScore) {
      alert(`Il punteggio deve essere un numero compreso tra 0 e ${maxScore}`);
      return;
    }
    
    onConfirm(scoreValue);
    setNewScore(""); 
  };

  const handleScoreChange = (e) => {
    const value = e.target.value;
    // Permetti solo numeri
    if (value === '' || /^[0-9]+$/.test(value)) {
      setNewScore(value);
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box style={{ padding: '20px', minWidth: '350px', maxWidth: '450px' }}>
        {/* TITOLO */}
        <Typography variant="h6" component="h3" gutterBottom>
          Modifica Score Step {stepIndex + 1}
        </Typography>
        
        {/* TESTO DESCRITTIVO */}
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: '12px' }}>
          Inserisci il nuovo punteggio per questo step (max: {maxScore})
        </Typography>
        
        {/* INPUT NUMERICO */}
        <TextField
          fullWidth
          label="Nuovo Score"
          placeholder={`Inserisci un valore da 0 a ${maxScore}`}
          variant="outlined"
          margin="normal"
          value={newScore}
          onChange={handleScoreChange}
          type="number"
          inputProps={{
            min: 0,
            max: maxScore,
            step: 1
          }}
          helperText={`Punteggio attuale: ${currentScore}/${maxScore}`}
        />
        
        {/* BOTTONI IN BASSO */}
        <Box display="flex" justifyContent="flex-end" gap={1} marginTop={2}>
          <div className={classes.stepQuestion}>
            <Box className={classes.buttonsContainer}>
              <Button 
                variant="outlined"
                onClick={handleConfirm}
              >
                Salva
              </Button>
            </Box>
          </div>
        </Box>
      </Box>
    </Popover>
  );
};

export default EditScorePopover;
